import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CargaDescargaEADDto;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Tipo", cell: x => ({ data: models.TipoCargaDescarga[x.Tipo] }) },
    { title: "Camión", cell: x => ({ data: x.NombreCamion }) },
    { title: "Status", cell: x => ({ data: models.StatusCargaDescarga[x.Status] }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
    { title: "Chofer", cell: x => ({ data: x.NombreChofer }) },
    { title: "Ruta", cell: x => ({ data: x.NombreRutaEAD }) },
    { title: "Usuario capturó", cell: x => ({ data: x.NombreUsuario }) },
    { title: "Fecha inicio", cell: x => ({ data: kea.toDate(x.FechaInicio) }) },
    { title: "Fecha terminó", cell: x => ({ data: kea.toDate(x.FechaTermino) }) },
    { title: "Fecha canceló", cell: x => ({ data: kea.toDate(x.FechaCancelo) }) },
    { title: "Tiene servicios incluídos", cell: x => ({ data: x.TieneServiciosIncluidos }) },
    { title: "Tiene guias incompletas", cell: x => ({ data: x.TieneGuiasIncompletas }) },
    { title: "Folio", cell: x => ({ data: x.Folio }) },
];

export interface BotonesDeps {
    onCancelar: (x: Entity) => void;
    onVer: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): Column[] {
    const botones = kea.columnaBotones([
        {
            iconClass: fa("eye"),
            onClick: deps.onVer,
            tooltip: "Ver"
        }, {
            iconClass: fa("times"),
            onClick: deps.onCancelar,
            style: "danger",
            tooltip: "Cancelar"
        }
    ]);
    return [botones, ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cargasEAD/list/columns.tsx